import { GET_VENDOR_DETAILS, SET_VENDOR_DETAILS } from "./VendorDetailsType";

const getVendorDetails = (searchText: string) => ({
    type: GET_VENDOR_DETAILS,
    searchText: searchText
});

const setVendorDetails = (vendorDropDownList: any) => ({
    type: SET_VENDOR_DETAILS,
    vendorDropDownList: vendorDropDownList
});

export {
    getVendorDetails,
    setVendorDetails
}
